import React from "react";

type PricingModalProps = {
  open: boolean;
  onClose: () => void;
  onJoinWaitlist?: () => void;
};

const plans = [
  {
    name: "Monthly",
    price: "$9.99/mo",
    trial: "",
    description: "Billed monthly. Cancel anytime.",
  },
  {
    name: "Annual",
    price: "$29.99/yr",
    trial: "7-day free trial",
    description: "Save 75% with annual billing.",
    highlight: true,
  },
];

const PricingModal: React.FC<PricingModalProps> = ({ open, onClose, onJoinWaitlist }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8 relative border border-gray-200">
        {/* Close button */}
        <button
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 text-2xl"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        <div className="text-center mb-8">
          <h2 className="text-3xl font-extrabold mb-2">Choose Your Plan</h2>
          <p className="text-lg text-gray-700">Sign up to be the first to know when the app is ready to download.</p>
        </div>
        <div className="flex flex-col md:flex-row gap-6 mb-8">
          {plans.map((plan, i) => (
            <div
              key={plan.name}
              className={`flex-1 bg-white rounded-xl border shadow-sm p-6 flex flex-col items-center text-center ${plan.highlight ? 'border-[#b89b56] shadow-lg' : 'border-gray-200'}`}
            >
              <div className="text-lg font-bold mb-1">{plan.name}</div>
              <div className="text-3xl font-extrabold mb-2">{plan.price}</div>
              {plan.trial && <div className="text-green-700 font-semibold mb-2">{plan.trial}</div>}
              <div className="text-gray-600 mb-2">{plan.description}</div>
            </div>
          ))}
        </div>
        <button
          className="w-full px-6 py-3 bg-black text-white rounded-md text-lg font-semibold hover:bg-gray-900 transition"
          onClick={() => {
            if (onJoinWaitlist) onJoinWaitlist();
          }}
        >
          Join the Waitlist
        </button>
      </div>
    </div>
  );
};

export default PricingModal; 